import { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ThemeContextProvider } from './contexts/ThemeContext'
import { AppRouter } from './router/AppRouter'
import { useEnumsStore } from './stores/enumsStore'
import { useAuthBootstrap } from './hooks/useAuthBootstrap'
import { AuthenticatedNotificationsLayer } from './components/notifications/AuthenticatedNotificationsLayer'
import './App.css'

const MODAL_OPEN_CLASS = 'easya-modal-open'

/** Блокирует скролл при открытом MUI Modal/Menu/Select (disableScrollLock в теме отключил встроенный lock). */
function useModalScrollLock() {
  useEffect(() => {
    const lock = () => {
      const open = document.body.querySelector('[class*="MuiModal-root"]')
      if (open) {
        document.documentElement.style.overflow = 'hidden'
        document.body.style.overflow = 'hidden'
        document.body.classList.add(MODAL_OPEN_CLASS)
      } else {
        document.documentElement.style.overflow = ''
        document.body.style.overflow = ''
        document.body.classList.remove(MODAL_OPEN_CLASS)
      }
    }
    lock()
    const observer = new MutationObserver(() => {
      requestAnimationFrame(lock)
    })
    observer.observe(document.body, { childList: true, subtree: true })
    return () => {
      observer.disconnect()
      document.documentElement.style.overflow = ''
      document.body.style.overflow = ''
      document.body.classList.remove(MODAL_OPEN_CLASS)
    }
  }, [])
}

function App() {
  const loadEnums = useEnumsStore((state) => state.loadEnums)
  useModalScrollLock()
  useAuthBootstrap()

  useEffect(() => {
    loadEnums()
  }, [loadEnums])

  return (
    <ThemeContextProvider>
      <BrowserRouter>
        <AppRouter />
        <AuthenticatedNotificationsLayer />
      </BrowserRouter>
    </ThemeContextProvider>
  )
}

export default App
